<div id="popup-layout"
  class="!tw-font-['Roboto'] container tw-text-base tw-bg-transparent tw-z-[100000] tw-bg-white tw-flex tw-flex-col animate-fade-in"
  [ngClass]="{ 'tw-w-min-[420px] tw-w-[420px]': !widthAuto, 'tw-fixed tw-top-6 tw-right-3 tw-rounded-xl tw-shadow-lg tw-shadow-black/25': injected }">
  <ng-content></ng-content>
</div>
